import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface RecommendationsListProps {
  recommendations: string[];
}

export function RecommendationsList({ recommendations }: RecommendationsListProps) {
  return (
    <Card className="mb-6 border-0 shadow-xl bg-white/90 backdrop-blur-sm">
      <CardHeader className="pb-4">
        <CardTitle className="text-xl font-semibold text-black">
          Key Recommendations
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {recommendations.slice(0, 6).map((recommendation, index) => (
            <div key={index} className="flex gap-3 p-4 bg-gradient-to-r from-gray-50 to-gray-100/50 rounded-xl hover:shadow-md transition-all duration-300">
              <div className="flex-shrink-0 w-6 h-6 bg-gradient-to-br from-brand-orange to-orange-600 text-white rounded-full flex items-center justify-center text-xs font-bold shadow-lg">
                {index + 1}
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{recommendation}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}